import { z, ZodType } from 'zod';

export const JACKPOT_TYPES = {
	gold: 2,
	silver: 1,
	bronze: 0,
} as const satisfies Record<string, number>;

export type JackpotType = (typeof JACKPOT_TYPES)[keyof typeof JACKPOT_TYPES];

export const jackpotTypeSchema: ZodType<JackpotType> = z.nativeEnum(JACKPOT_TYPES);
